import { Box, Container, Divider, Typography } from "@mui/material";
import { useRouteError } from "react-router-dom";

export function ErrorPage() {
  const error = useRouteError() as any;
  const errorMessage = error?.message;
  return (
    <Container
      sx={{
        py: 10,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          mb: 2,
        }}
      >
        Error: {error?.statusText ?? ""}
        <Typography
          component="span"
          variant="subtitle1"
          sx={{
            ml: 2,
            color: "white",
          }}
        >
          (Well, you really fucked that up.)
        </Typography>
      </Typography>
      {errorMessage && (
        <Box bgcolor="#dfdfdf" p={4}>
          <code>{errorMessage}</code>
        </Box>
      )}
      <Divider sx={{ marginY: 4 }} />
      <Typography component="div" variant="body1">
        <p>
          Just for today, we kindly invite you to reflect on a little mishap
          that has occurred during your online journey. As fate would have it,
          an error has manifested itself within your web browser. Now, before we
          delve further, let's take a moment to acknowledge that errors are mere
          hiccups in the vast realm of technology. They come and go, teaching us
          lessons along the way.
        </p>

        <p>
          However, dear traveler of the digital realm, it appears that this
          error might have a humble origin, nestled somewhere within your own
          actions. Oh, the irony! It seems a misstep or two might have led you
          astray, causing this unfortunate disruption. But fret not, for we all
          make mistakes, and you, my friend, are no exception.
        </p>

        <p>
          Let us consider the lessons to be learned. Perhaps, just perhaps, a
          touch more caution and mindfulness on your part could have prevented
          this mishap. Did you click a bit too hastily? Or venture into unknown
          territories without due diligence? Ah, the wonders of hindsight!
        </p>

        <p>
          So, as you sit there, staring at the error message with a mixture of
          frustration and bemusement, take a deep breath. Embrace this moment as
          an opportunity to grow, to evolve, and to realize that sometimes, our
          digital escapades require a modicum of prudence.
        </p>

        <p>
          Remember, dear internet traveler, that the vast cyberspace is a
          labyrinth of codes, algorithms, and perplexing technology. It demands
          respect and a dash of awareness. Approach it with a touch more care,
          and you shall navigate its virtual realms with greater ease.
        </p>

        <p>
          Now, go forth, dear browser user, armed with newfound wisdom and the
          willingness to accept your role in this little hiccup. May your future
          online adventures be error-free, or at the very least, filled with
          fewer mishaps caused by your own human foibles.
        </p>

        <p>
          <Typography component="span" variant="body1" fontWeight={800}>
            Just for today:{" "}
          </Typography>
          Let us all strive to be more vigilant, more conscious, and more
          forgiving of ourselves and our digital encounters.
        </p>
      </Typography>
    </Container>
  );
}
